import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  AppBar,
  Toolbar,
  TextField,
  Button,
  Paper,
  CircularProgress,
  Container,
  CssBaseline,
  Snackbar,
  SnackbarContent,
  IconButton,
  Input,
  InputLabel,
  FormControl,
  FormHelperText,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Select,
  MenuItem,
  Avatar,
  Grid,
  CardContent,
  useMediaQuery,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {
  Error,
  Close,
  Email,
  Help,
  WebAsset,
  Timeline,
  Equalizer,
  DirectionsBus,
} from "@material-ui/icons";

import { useHistory } from "react-router-dom";
import MaskedInput from "react-text-mask";
import { useSnackbar } from "notistack";

import PinInput from 'react-pin-input'

import icon from "../../assets/img/logo_white.svg";
import CardShowcase from "../../assets/svg/cards.svg";

import Footer from "./footer.jsx";

import { withLocalize, Translate } from "react-localize-redux";
import { AdminService, FinanceService, ReportingService, Validator } from "../../utils/web_config.jsx";
import axiosRetry from "axios-retry";
const axios = require("axios");
axiosRetry(axios, { retries: 3 });

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  paper: {
    padding: 15,
  },
  btn: {
    textTransform: "capitalize",
  },
}));

function MaskedNID(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        " ",
        /\d/,
        /\d/,
      ]}
      placeholderChar={"\u2000"}
      showMask={false}
      keepCharPositions={true}
    />
  );
}

function TextMaskPhone(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        "2",
        "5",
        "0",
        " ",
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
        " ",
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={"\u2000"}
      showMask={false}
      keepCharPositions={false}
    />
  );
}

const outlets=[
  {code:"IIS1001CO",name:"CHIC COGEBANQUE"},
  {code:"IIS1002CE",name:"Nyabugogo bus park"},
  {code:"IIS1003CE",name:"Giporoso bus park"},
  {code:"IIS1004CE",name:"Musanze bus park"},
  {code:"IIS1005CE",name:"Kayonza bus park"},
  {code:"IIS1006CE",name:"Kinigi"},
  {code:"IIS1007CE",name:"Gahunga"},
  {code:"IIS1008CE",name:"Cyanika"},
  {code:"IIS1009CE",name:"Vunga"},
]


function EkashRegistration(props) {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [accountData, setAccountData] = useState({});
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [nid, setNid] = useState({ value: "", error: "" });
  const [idData, setIdData] = useState({
    loading: false,
    saving: false,
    open: false,
  });

  const [otpData, setOtpData] = useState({
    loading: false,
    saving: false,
    open: false,
    data: [],
  });

  const [otp, setOtp] = useState({ value: "", error: "" });

  const [clientFirstName, setFirstName] = useState({ value: "", error: "" });
  const [clientMiddleName, setMiddleName] = useState({ value: "", error: "" });
  const [clientLastName, setLastName] = useState({ value: "", error: "" });
  const [clientPhoneNumber, setPhoneNumber] = useState({
    value: "",
    error: "",
  });

  const [clientEmail, setEmail] = useState({ value: "", error: "" });
  const [clientLocation, setLocation] = useState({ value: "", error: "" });
  const [clientBranch, setBranch] = useState({ value: "", error: "" });
  const [company, setCompany] = useState({ value: "", error: "" });


  useEffect(() => {
    var accountData = new AdminService().accountData;
    setAccountData(accountData);
  }, []);

  const onNidChange = (event) => {
    if (event.target.value === "") {
      setNid({ value: "", error: "Enter ID number to continue" });
    } else {
      setNid({ value: event.target.value, error: "" });
    }
  };

  const onOtpChange = (v,i) => {
    if (v === "") {
      notify( "error", "Enter OTP number sent to your phone" );
    } else {
      setOtp({ value: v, error: "" });
    }
  };

  const onSearchClick = () => {
    if (nid.value === "") {
      setNid({ value: "", error: "Enter Card number" });
    } else {
      getIDInfo();
    }
  };



  ///////////////////////////////////
  /////////////////////
  const notify = (variant, msg, status) => {
    // if (status == 401) {
    //   history.push("/", { expired: true });
    // }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };
  ///////////////////////////////////

  const getIDInfo = () => {
    const createInstance = axios.create(
      new AdminService().getMsHeaders(accountData.token)
    );

    setIdData({ ...idData, loading: true });

    const data = {
      card_number: nid.value,
    };

    createInstance
      .post(new FinanceService().VALIDATE_ACCOUNT, data)
      .then(function (response) {
        setIdData({ ...idData, loading: false });
        const d = response.data;
        setIdData({ ...idData, loading: false, data: d.data, open: true });
      })
      .catch(function (error) {
        setIdData({ ...idData, loading: false });

        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }

        notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
      });
  };

  ///////////////////////////////////


  const [checked,setChecked]=useState(false);

  //////////////////////////////////////////
  const doRegister = () => {
  
    if (otp.value === "") {
      setOtp({ value: "", error: "Enter OTP number sent to your phone" });
      return;
    } 

    register()
  };

    ///////////////////////////////////

    const register = () => {
      const createInstance = axios.create(
        new AdminService().getMsHeaders(accountData.token)
      );
  
      setIdData({ ...idData, saving: true });
 
      const data ={
        "card_number": nid.value,
        "otp": otp.value
      }
  
      createInstance
        .post(new FinanceService().EKASH_REGISTRATION, data)
        .then(function (response) {
          setChecked(false);
          setIdData({ ...idData, saving: false });      
          setIdData({})
          notify("success", "Your registration request was sent successfully, You will receive confirmation SMS shortly.");
        })
        .catch(function (error) {
          setIdData({ ...idData, saving: false });
          setChecked(false);
          var e = error.message;
          if (error.response) {
            e = error.response.data.message;
          }
  
          notify(error?.response?.status==404?"info":"error", e, error?.response?.status);
        });
    };

  return (
    <div className={classes.root}>
      <CssBaseline />
      {/* Dialogs---------------------- */}
      <Dialog
        open={idData.open}
        // open={true}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        onClose={() => setIdData({ ...idData, open: false })}
      >
        <DialogTitle id="alert-dialog-title">
          Complete eKash Registration
        </DialogTitle>
          <DialogContent>
          Dear <b>{idData?.data?.account_name}</b>, please confirm eKash registration of <b>{idData?.data?.account_number}</b> by
            entering OTP code sent to your phone number
            <Box mt={3} width={1} display='flex' justifyContent='center'>
            <PinInput 
            length={6} 
            initialValue=""
            onChange={onOtpChange}
            type="numeric" 
            inputMode="number"
            style={{padding: '10px',borderRadius:"7px"}}  
            inputStyle={{borderColor: theme.palette.secondary.main}}
            inputFocusStyle={{borderColor: theme.palette.primary.main}}
            onComplete={(value, index) => {}}
            autoSelect={true}
            />
             
            </Box>
          <Box mt={2}>
            {" "}
            <FormControlLabel
              control={<Checkbox  checked={checked} name="terms" onChange={(e) => { setChecked(e.target.checked); }} />}
              label="Agree to our Terms&Conditions?"
            />
          </Box>
          </DialogContent>
  
        <DialogActions>
          <Button
            onClick={() => {
              if(!otpData.open){
              setIdData({  open: false });
              }
            }}
            variant="outlined"
            color="primary"
          >
           {!otpData.open? <Translate id="users.forms.buttons.cancel" />:<Translate id="users.forms.buttons.back" />}
          </Button>
          <Button
            disabled={idData.saving}
            variant="contained"
            color="primary"
            onClick={() => {
              if (checked) {
                doRegister();
              } 
            }}
            disableElevation
          >
            {idData.saving ? (
              <CircularProgress size={23} />
            ) : otpData.open ? (
              "Confirm"
            ) : (
              "Continue"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ------------------------- */}
      <AppBar position="static" color="primary" elevation={0}>
        <Toolbar>
          <Box mr={2}>
            <img
              src={icon}
              style={{ height: 45 }}
              className={classes.icon}
              alt="Icon"
              onClick={() => history.push("/")}
            />
          </Box>
          <Typography variant="h5" className={classes.title}>
           eKash Registration 
          </Typography>
          <IconButton>
            <Help />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm">
        <Box pt={10}>
          <Box p={2} display="flex" flexDirection="column">
            <img
              src={CardShowcase}
              style={{ height: 170 }}
              alt="Cards showcase"
            />
            <Box
              mb={1}
              display="flex"
              alignItems="center"
              justifyContent="center"
            ></Box>
            <Typography color="textSecondary" align="center">
              Enter your PAN number or Serial Number(CENT) for eKash registration.
            </Typography>
          </Box>
          <Box mt={3}>
            <FormControl fullWidth error={nid.error != ""}>
              <InputLabel htmlFor="formatted-code" size="small">
                Card Number
              </InputLabel>
              <Input
                onChange={onNidChange}
                value={nid.value}
                color="primary"
                varient="outlined"
                // inputComponent={MaskedNID}
                placeholder="Card Number"
              />
              <FormHelperText id="code">{nid.error}</FormHelperText>
            </FormControl>
          </Box>

          <Box mt={2} mb={2}>
            <Button
              disabled={idData.loading}
              color="primary"
              fullWidth
              variant="contained"
              disableElevation
              onClick={() => {
                onSearchClick();
              }}
              className={classes.btn}
            >
              {idData.loading ? <CircularProgress size={23} /> : "Continue"}
            </Button>
          </Box>
        </Box>
      </Container>
      <Container maxWidth="lg">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mt={12}
          alignContent="center"
          width={1}
        >
          <div className={classes.ln2} />
          <Typography variant="h5" gutterBottom>
            <b>Pre-registration benefits</b>
          </Typography>
          <div className={classes.ln} />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mb={10}
          alignContent="center"
          width={1}
        >
          <Box width={!fullScreen ? 1 / 2 : 1}>
            <Typography align="center">
              Card pre-registration is a way of booking your SafariBus card
              online and get it at one of our branches without waiting in
              queues.
            </Typography>
          </Box>
        </Box>

        <Grid container justify="center" alignContent="center">
          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2}>
                <Avatar className={classes.green}>
                  <Timeline fontSize="large" />
                </Avatar>
              </Box>

              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2}>
                <Avatar className={classes.green}>
                  <Equalizer fontSize="large" />
                </Avatar>
              </Box>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2}>
                <Avatar className={classes.green}>
                  <DirectionsBus fontSize="large" />
                </Avatar>
              </Box>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                No queues
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                Don't waste your time queuing on our branches for your card, do
                your registration before and you will come only to pick it after
                showing your ID number.
              </Typography>
            </CardContent>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </div>
  );
}

export default withLocalize(EkashRegistration);
